import { render, staticRenderFns } from "./ExchangePrizeModal.vue?vue&type=template&id=b7890416&"
import script from "./ExchangePrizeModal.vue?vue&type=script&lang=js&"
export * from "./ExchangePrizeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports